import React, { useEffect } from 'react'
import { Col } from '@gympass/yoga'
import { FormattedMessage } from 'react-intl'
import { useHistory } from 'react-router-dom'

import { askForEmailConfirmation } from '@client/services/confirmEmail'

import useInternationalization from '@hooks/useInternationalization'
import useFunnelStage from '@hooks/useFunnelStage'
import useContact from '@hooks/useContact'
import useRouteBuilder from '@hooks/useRouteBuilder'

import { tangoPressButton } from '@assets'

import Appbar from '@components/Appbar'
import Footer from '@components/Footer'

import * as Style from './ConfirmEmail.style'

export default function ConfirmEmail() {
  const { countryFullName, country, language } = useInternationalization()
  const { contact } = useContact()
  const { setFunnelStage } = useFunnelStage(countryFullName)

  const { buildRoute } = useRouteBuilder()
  const history = useHistory()

  function addFunnelStage() {
    const data = {
      id: contact.id,
      email: contact.email,
      funnelStage: 'confirm_email',
    }
    setFunnelStage(data)
  }

  async function postConfirmEmail() {
    const { email, magicLink } = contact
    const finalLanguage = language === 'pt' ? 'pt-BR' : language
    try {
      await askForEmailConfirmation({
        email,
        country,
        language: finalLanguage,
        magicLink,
      })
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    addFunnelStage()
    if (contact.email) {
      postConfirmEmail(contact.email)
    }
  }, [])

  function returnCompanyInfo() {
    history.push(buildRoute('/simulate/company-info?email-flow=true'))
  }

  return (
    <>
      <Appbar />
      <Style.Header>
        <Style.Container>
          <Style.Row>
            <Col xxs={12} xl-start={3} xl={6}>
              <Style.Title>
                <FormattedMessage id="smb_acquisition_confirm_email.title" />
              </Style.Title>

              <Style.Text>
                <FormattedMessage
                  id="smb_acquisition_confirm_email.first_paragraph"
                  values={{
                    contactEmail: contact.email,
                    strong: (...chunks) => (
                      <Style.TextEmail>{chunks}</Style.TextEmail>
                    ),
                  }}
                />
              </Style.Text>

              <Style.Text>
                <FormattedMessage id="smb_acquisition_confirm_email.second_paragraph" />
              </Style.Text>

              <Style.Link onClick={returnCompanyInfo}>
                <FormattedMessage id="smb_acquisition_confirm_email.call_to_action" />
              </Style.Link>
            </Col>

            <Col hide={['xxs', 'xs', 'sm', 'md', 'lg']} xl={1}>
              <img src={tangoPressButton} alt="cartoon hand press button" />
            </Col>
          </Style.Row>
        </Style.Container>
      </Style.Header>

      <Footer company="Gympass B.V." />
    </>
  )
}
